import { APIPOST, APICONTACTFORM } from '../utils/apiHelper';
import { UPLOAD_CV_FORM, SEND_SIMPLE_CONTACT_FORM, SEND_REPAIR_FORM, LUHN_CHECK } from './actions.type';
import i18n from '../i18n';

const state = {
  //
};

const getters = {
  //
};

const actions = {
  async [SEND_SIMPLE_CONTACT_FORM](context, contactForm) {
    const formData = new FormData();
    const temp = contactForm;
    const json = JSON.stringify(temp);
    formData.append('data', json);
    try {
      const response = await APICONTACTFORM('services/Webportal/Contact', formData);
      if (response) {
        return response;
      }
      return { error: true, message: 'ERROR' };
    } catch (err) {
      return { error: true, message: err };
    }
  },
  async [SEND_REPAIR_FORM](context, contactForm) {
    const lang = i18n.locale.substring(0, 2);
    const formData = new FormData();
    const temp = contactForm.form;
    const json = JSON.stringify(temp);
    formData.append('data', json);
    formData.append('invoice', contactForm.attachment.invoice);
    formData.append('warranty_card', contactForm.attachment.warrantyCard);
    try {
      const response = await APICONTACTFORM(`services/webportal/Mobilfutar/${lang}`, formData);
      if (response) {
        return response;
      }
      return { error: true, message: 'ERROR' };
    } catch (err) {
      return { error: true, message: err };
    }
  },
  async [LUHN_CHECK](context, imei) {
    const formData = new FormData();
    formData.append('imei', imei);
    try {
      const response = await APICONTACTFORM('services/utils/Luhn', formData);
      if (response) {
        return response;
      }
      return { error: true, message: 'ERROR' };
    } catch (err) {
      return { error: true, message: err };
    }
  },
  async [UPLOAD_CV_FORM](context, contactForm) {
    const formData = new FormData();
    const temp = contactForm.form;
    const json = JSON.stringify(temp);
    formData.append('data', json);
    formData.append('cv', contactForm.attachment.cv);
    formData.append('motivation_letter', contactForm.attachment.document);
    try {
      const response = await APICONTACTFORM('services/Career/CreateJobApplication', formData);
      if (response) {
        return response;
      }
      return { error: true, message: 'ERROR' };
    } catch (err) {
      return { error: true, message: err };
    }
  },
};

const mutations = {
  //
};

export default {
  state,
  actions,
  mutations,
  getters,
};
